import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { site, nav } from '../mock';

const LOGO_SRC = '/brand/gg-logo.jpg';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0f1e39] text-slate-200 mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="inline-block bg-white rounded-sm p-3 shadow-sm">
            <img src={LOGO_SRC} alt="The Garlick Group logo" className="h-14 w-auto block" draggable={false} />
          </div>
          <p className="mt-5 text-[14px] leading-relaxed text-slate-300/90 max-w-xs">
            {site.tagline}
          </p>
        </div>

        <div>
          <div className="text-[12px] uppercase tracking-widest text-slate-400 mb-4">Services</div>
          <ul className="space-y-2 text-[14px]">
            {nav.services.map(s => (
              <li key={s.slug}><Link to={`/services/${s.slug}`} className="text-slate-300 hover:text-white link-underline">{s.title}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-[12px] uppercase tracking-widest text-slate-400 mb-4">Who We Serve</div>
          <ul className="space-y-2 text-[14px]">
            {nav.audiences.map(a => (
              <li key={a.slug}><Link to={`/who-we-serve/${a.slug}`} className="text-slate-300 hover:text-white link-underline">{a.title}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-[12px] uppercase tracking-widest text-slate-400 mb-4">Contact</div>
          <ul className="space-y-3 text-[14px] text-slate-300">
            <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-slate-400" /><span>{site.address}</span></li>
            <li className="flex items-center gap-3"><Mail size={16} className="text-slate-400" /><a href={`mailto:${site.email}`} className="hover:text-white">{site.email}</a></li>
            <li className="flex items-center gap-3"><Phone size={16} className="text-slate-400" /><a href={site.phoneHref} className="hover:text-white">{site.phone}</a></li>
          </ul>
          <Link to="/contact" className="mt-5 inline-block bg-white text-[#1F3864] text-[13px] font-semibold px-4 py-2 rounded-sm hover:bg-slate-100">Request Consultation</Link>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-[12px] text-slate-400">
          <div>© {year} {site.fullName}. All rights reserved.</div>
          <div className="flex items-center gap-5">
            <Link to="/about" className="hover:text-white">About</Link>
            <Link to="/articles" className="hover:text-white">Articles</Link>
            <Link to="/contact" className="hover:text-white">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
